"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var markdown_service_1 = require("./markdown.service");
var MarkdownComponent = /** @class */ (function () {
    function MarkdownComponent(element, markdownService) {
        this.element = element;
        this.markdownService = markdownService;
        this.error = new core_1.EventEmitter();
    }
    Object.defineProperty(MarkdownComponent.prototype, "data", {
        get: function () { return this._data; },
        set: function (value) {
            this._data = value;
            this.render(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkdownComponent.prototype, "src", {
        get: function () { return this._src; },
        set: function (value) {
            var _this = this;
            this._src = value;
            this.markdownService
                .getSource(value)
                .subscribe(function (markdown) { return _this.render(markdown); }, function (error) { return _this.error.emit(error); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MarkdownComponent.prototype, "isTranscluded", {
        get: function () {
            return !this.data && !this.src;
        },
        enumerable: true,
        configurable: true
    });
    MarkdownComponent.prototype.ngAfterViewInit = function () {
        if (this.isTranscluded) {
            this.render(this.element.nativeElement.innerHTML);
        }
    };
    MarkdownComponent.prototype.render = function (markdown) {
        this.element.nativeElement.innerHTML = this.markdownService.compile(markdown);
        this.markdownService.highlight();
    };
    MarkdownComponent.decorators = [
        { type: core_1.Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'markdown, [markdown]',
                    template: '<ng-content></ng-content>',
                    styles: [":host /deep/ table{border-spacing:0;border-collapse:collapse;margin-bottom:16px}:host /deep/ table td,:host /deep/ table th{padding:6px 13px;border:1px solid #ddd}:host /deep/ table tr:nth-child(2n){background-color:rgba(0,0,0,.03)}:host /deep/ blockquote{padding:0 1em;color:rgba(0,0,0,.535);border-left:.25em solid rgba(0,0,0,.11)}"],
                },] },
    ];
    /** @nocollapse */
    MarkdownComponent.ctorParameters = function () { return [
        { type: core_1.ElementRef, },
        { type: markdown_service_1.MarkdownService, },
    ]; };
    MarkdownComponent.propDecorators = {
        "data": [{ type: core_1.Input },],
        "src": [{ type: core_1.Input },],
        "error": [{ type: core_1.Output },],
    };
    return MarkdownComponent;
}());
exports.MarkdownComponent = MarkdownComponent;
//# sourceMappingURL=markdown.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-markdown/dist/lib/markdown.component.js
// module id = ./node_modules/ngx-markdown/dist/lib/markdown.component.js
// module chunks = vendor